import {
  ClearRefinementsProps,
  useClearRefinements,
  useSearchBox,
} from 'react-instantsearch-hooks-web';
import { useSearchDictionary } from 'components/helpers/AlgoliaSearch/util';
import { classnames } from 'tailwindcss-classnames';
import { Dispatch, SetStateAction } from 'react';

type ClearFacetsProps = ClearRefinementsProps & {
  setType: Dispatch<SetStateAction<string>>;
  resetAutocomplete: () => void;
};

function Reset({ setType, resetAutocomplete, ...props }: ClearFacetsProps) {
  const { refine, canRefine } = useClearRefinements(props);
  const { refine: setQuery } = useSearchBox();
  const dict = useSearchDictionary();
  const onClick = () => {
    if (canRefine) {
      refine();
    }
    setQuery('');
    setType('');
    resetAutocomplete();
  };
  return (
    <div>
      <button
        type="button"
        onClick={onClick}
        className={classnames(
          'bg-theme-btn-secondary-bg',
          'rounded-full',
          'font-semibold',
          'border',
          'border-2',
          'border-blue',
          'mt-4',
          'text-base',
          'text-blue',
          'px-6',
          'py-2',
          'w-full',
          'md:w-auto'
        )}
      >
        {dict.reset}
      </button>
    </div>
  );
}

export default Reset;
